import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actionCorreoGetById } from "../../redux/actions/correos/correos";
import { relativeTime } from "../../utils/relativeTime";
import "../../assets/css/correos.css";

function fmtFecha(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("es-MX", {
    weekday: "long", day: "numeric", month: "long",
    year: "numeric", hour: "2-digit", minute: "2-digit",
  });
}

function pageTitle(correo) {
  const trabajador = correo.nombre_trabajador;
  const empresa    = correo.nombre_empresa;
  if (trabajador && empresa) return `${trabajador} vs ${empresa}`;
  if (trabajador) return trabajador;
  return correo.evento_titulo || correo.evento_tipo || `Correo #${correo.id_correo}`;
}

function CorreosDetallePage() {
  const navigate  = useNavigate();
  const dispatch  = useDispatch();
  const { id }    = useParams();

  const [correo,  setCorreo]  = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    dispatch(actionCorreoGetById(id))
      .then((data) => { if (alive) setCorreo(data); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [dispatch, id]);

  if (loading) {
    return (
      <div className="cr-detail-root">
        <div className="cr-empty"><div className="cr-empty-icon">⏳</div><p>Cargando…</p></div>
      </div>
    );
  }

  if (!correo) {
    return (
      <div className="cr-detail-root">
        <div className="cr-empty"><div className="cr-empty-icon">❌</div><p>Correo no encontrado.</p></div>
      </div>
    );
  }

  const isManana  = correo.is_manana === 1;
  const tipoClass = isManana ? "manana" : "hora";
  const titulo    = pageTitle(correo);
  const tipo      = (correo.evento_tipo || "").toLowerCase();
  const categoria = tipo.includes("onvenio")
    ? "Convenios de Pago"
    : tipo.includes("reliminar")
      ? "Audiencias Preliminares"
      : "Audiencias Conciliacion";

  return (
    <div className="cr-detail-root">
      <div className="cr-detail-wrapper">
        <button type="button" className="cr-back" onClick={() => navigate("/correos")}>
          ← Regresar a correos
        </button>

        <div className="cr-detail-card">
          <div className="cr-detail-header">
            <div>
              <h2>{titulo}</h2>
              <p>
             
                Enviado {relativeTime(correo.datetime)}
              </p>
            </div>
            <span className="cr-chip">{categoria}</span>
          </div>

          <div className="cr-detail-grid">
            {correo.nombre_trabajador && (
              <div className="cr-detail-field">
                <label>Trabajador</label>
                <span>{correo.nombre_trabajador}</span>
              </div>
            )}
            {correo.nombre_empresa && (
              <div className="cr-detail-field">
                <label>Empresa</label>
                <span>{correo.nombre_empresa}</span>
              </div>
            )}
            <div className="cr-detail-field">
              <label>Tipo de correo</label>
              <span>{correo.evento_tipo || "—"}</span>
            </div>
            <div className="cr-detail-field">
              <label>Tipo de recordatorio</label>
              <span>{isManana ? "Un día antes (mañana)" : "Una hora antes"}</span>
            </div>
            <div className="cr-detail-field">
              <label>Fecha del evento</label>
              <span>{fmtFecha(correo.evento_fecha_inicio)}</span>
            </div>
            <div className="cr-detail-field">
              <label>Fecha de envío</label>
              <span>{fmtFecha(correo.datetime)}</span>
            </div>
            {correo.evento_lugar && (
              <div className="cr-detail-field">
                <label>Lugar</label>
                <span>{correo.evento_lugar}</span>
              </div>
            )}
            {correo.evento_descripcion && (
              <div className="cr-detail-field">
                <label>Descripción</label>
                <span>{correo.evento_descripcion}</span>
              </div>
            )}
            <div className="cr-detail-field">
              <label>Categoría</label>
              <span>{categoria}</span>
            </div>
            <div className="cr-detail-field">
              <label>Total destinatarios</label>
              <span>{correo.destinatarios?.length ?? 0} correo{correo.destinatarios?.length !== 1 ? "s" : ""}</span>
            </div>
          </div>
        </div>

        <div className="cr-recipients-card">
          <div className="cr-recipients-head">
            <h3>Correos enviados a</h3>
            <span className="cr-chip">{correo.destinatarios?.length ?? 0} destinatarios</span>
          </div>

          {correo.destinatarios?.length > 0 ? (
            <table className="cr-recipients-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Correo electrónico</th>
                  <th>Fecha de envío</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {correo.destinatarios.map((d, idx) => (
                  <tr key={d.id_correo_user}>
                    <td style={{ color: "#94a3b8", fontWeight: 600 }}>{idx + 1}</td>
                    <td style={{ fontWeight: 600 }}>{d.correo}</td>
                    <td>
                      {d.enviado_en
                        ? new Date(d.enviado_en).toLocaleString("es-MX", {
                            day: "numeric", month: "short", year: "numeric",
                            hour: "2-digit", minute: "2-digit",
                          })
                        : "—"}
                    </td>
                    <td>
                      <span className="cr-sent-dot">Enviado</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="cr-empty" style={{ padding: 32 }}>
              <p>Sin destinatarios registrados.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CorreosDetallePage;
